import React, {useEffect, useMemo, useRef, useState} from "react";

import {useLocation} from "react-router-dom";

import {useSelector} from "react-redux";

import {canInsertByLicense, isAdmin} from "../../../components/commonmethod/CommonMethod";

import {PageHeader} from "../../../components/PageHeader";

import CodeManageSettingsLayout from "../fieldMng/shared/CodeManageSettingsLayout";

import UserAccountManagePanel from "../userAccount/UserAccountManagePanel";

import UserGroupManagePanel from "../usergroup/UserGroupManagePanel";

import {

    pickBasicSettingsCategory,

    USER_ACCOUNT_GROUP_CATEGORIES,

    USER_ACCOUNT_GROUP_ROUTE_CATEGORY,

} from "./basicSettingsCategoryConfig";

import "../fieldMng/shared/unifiedCodeManage.css";

import "../fieldMng/shared/codeManageSettings.css";

const USER_ACCOUNT_PANEL_SUB_NAV = [
    {id: "active", label: "활성화 계정"},
    {id: "inactive", label: "비활성화 계정"},
];

function UserAccountGroupManage() {

    const location = useLocation();

    const userAccountPanelRef = useRef(null);
    const [userViewMode, setUserViewMode] = useState("list");

    const license = useSelector((state) => state.auth.license);

    const user = useSelector((state) => state.auth.user);

    const canInsert = canInsertByLicense({license, userCheck: true});

    const auth = isAdmin(user);

    const [userListType, setUserListType] = useState(true);

    const [activeCategory, setActiveCategory] = useState(() =>

        pickBasicSettingsCategory(

            USER_ACCOUNT_GROUP_CATEGORIES,

            "userAccount",

            USER_ACCOUNT_GROUP_ROUTE_CATEGORY,

            location.pathname,

        ),

    );



    const activeMeta = useMemo(

        () => USER_ACCOUNT_GROUP_CATEGORIES.find((item) => item.id === activeCategory)

            ?? USER_ACCOUNT_GROUP_CATEGORIES[0],

        [activeCategory],

    );



    useEffect(() => {

        const nextId = pickBasicSettingsCategory(

            USER_ACCOUNT_GROUP_CATEGORIES,

            activeCategory,

            USER_ACCOUNT_GROUP_ROUTE_CATEGORY,

            location.pathname,

        );

        if (nextId && nextId !== activeCategory) {

            setActiveCategory(nextId);

        }

    }, [location.pathname]);

    useEffect(() => {
        setUserViewMode("list");
    }, [activeCategory, userListType]);

    const isUserCreate = activeCategory === "userAccount" && userViewMode === "create";

    const fullPanel = activeCategory === "userAccount"

        ? (

            <UserAccountManagePanel

                ref={userAccountPanelRef}

                listType={userListType}
                viewMode={userViewMode}
                onViewModeChange={setUserViewMode}
            />

        )

        : <UserGroupManagePanel key="userGroup" />;



    const panelTitle = isUserCreate ? "사용자 등록" : activeMeta.title;
    const panelDescription = isUserCreate
        ? "새 사용자 계정을 등록합니다."
        : activeMeta.description;

    const panelHeadActions = activeCategory === "userAccount" && auth ? (
        isUserCreate ? (
            <>
                <button
                    type="button"
                    className="code-manage-neutral-btn"
                    onClick={() => setUserViewMode("list")}
                >
                    취소
                </button>
                <button
                    type="button"
                    className="save-btn"
                    onClick={() => userAccountPanelRef.current?.submitCreate?.()}
                >
                    등록
                </button>
            </>
        ) : (
            <>
                <button
                    type="button"
                    className={userListType ? "code-manage-delete-btn" : "code-manage-neutral-btn"}
                    onClick={() => userAccountPanelRef.current?.toggleAccountState?.()}
                >
                    {userListType ? "비활성화" : "활성화"}
                </button>
                {canInsert && userListType && (
                    <button
                        type="button"
                        className="save-btn"
                        onClick={() => setUserViewMode("create")}
                    >
                        등록
                    </button>
                )}
            </>
        )
    ) : null;



    return (

        <div className="common-container container-height-full">

            <PageHeader

                header="사용자 · 그룹 관리"

                indicator="환경설정 > 기본설정 > 사용자 · 그룹 관리"

            />

            <CodeManageSettingsLayout

                navItems={auth ? USER_ACCOUNT_GROUP_CATEGORIES : USER_ACCOUNT_GROUP_CATEGORIES.filter((item) => item.id !== "userGroup")}

                activeCategory={activeCategory}

                onCategoryChange={setActiveCategory}

                panelTitle={panelTitle}

                panelDescription={panelDescription}

                panelHeadActions={panelHeadActions}
                panelSubNav={activeCategory === "userAccount" && !isUserCreate ? USER_ACCOUNT_PANEL_SUB_NAV : null}
                panelSubNavValue={userListType ? "active" : "inactive"}
                onPanelSubNavChange={(value) => setUserListType(value === "active")}
                fullPanel={fullPanel}

            />

        </div>

    );

}



export default UserAccountGroupManage;

